// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { IconWrapper } from "@insite/mobius/Icon";
import { headerClickableStyles } from "@tps/App/Components/Header/HeaderClickable";
import { color, hideElement, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

headerClickableStyles.clickable = {
    css: css`
        &.mobile-mode {
            padding: 7px;
            display: flex;
            justify-content: center;
            ${xScreen("lte", "md")} {
                width: 32px;
                height: 32px;
            }
        }
        &:hover, &.opened {
            height: 25px;
            & .headerClickable-title, ${IconWrapper} {
                color: ${color("common.ui8")};
            }
            .arrow {
                transform: rotate(180deg);
            }
        }
        &:focus {
            outline: none;
        }
    `,
};
headerClickableStyles.title = {
    size: 14,
    weight: 700,
    color: "text",
    css: css`
        letter-spacing: 0;
        line-height: 22px;
        display: block;
        max-width: 110px;
        margin-left: 8px;
        margin-right: 8px;
        text-transform: capitalize;
        overflow: hidden;
        text-overflow: ellipsis;

        ${xScreen("lte", "md")} {
            ${hideElement}
        }
    `,
};
headerClickableStyles.icon = {
    color: "primary.main",
    size: 18,
};
headerClickableStyles.arrow = {
    size: 13,
    color: "common.ui4",
    css: css`
        &${IconWrapper}, svg {
            width: 9px;
            height: 13px;
        }
    `,
};
